<template>
  <div class="hidden w-28 bg-gray-800 lg:block">
    <div class="flex size-full flex-col">
      <nuxt-link
        to="/home"
        class="flex w-full shrink-0 basis-16 items-center justify-center border-b border-b-gray-800 bg-indigo-500 px-3 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600"
       
        @click="resetSelectedRollout"
      >
        <img
          class="w-full"
          src="~/assets/img/logo-white.svg"
          alt="Rollouter Logo"
        />
      </nuxt-link>
      <div class="flex flex-auto flex-col overflow-y-auto px-2 pt-6">
        <div class="w-full flex-1 space-y-1">
          <RolloutLink
            v-for="item in items"
            :key="item.name"
            v-slot="{ isActive }"
           
            :navigation-item="item"
            active-class="bg-white/10 text-white dark:text-gray-900"
            inactive-class="text-indigo-100 dark:text-gray-500 hover:bg-white/10 hover:text-white dark:hover:text-gray-900"
            class="group flex w-full flex-col items-center rounded-md p-3 text-xs font-medium"
            aria-current="page"
            @mouseenter="onItemHover(item)"
          >
            <component
              :is="iconMapping[item.name]"
              :class="[
                isActive
                  ? 'text-indigo-400'
                  : 'text-gray-400 group-hover:text-white dark:group-hover:text-gray-900',
                'size-6',
              ]"
              aria-hidden="true"
            />
            <span class="mt-2 text-center">
              {{ $t('navigation.' + item.name) }}
            </span>
          </RolloutLink>
        </div>
        <div class="pt-6 text-gray-400">
          <!-- Version -->
          <a
            href="//changelog.rollouter.com"
            target="_blank"
            class="block -mx-2 bg-gray-900 dark:bg-gray-50 text-gray-500 dark:text-gray-400 py-2 text-center text-xs hover:underline"
          >
            {{ `v${version}` }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  CogIcon,
  HomeIcon,
  ArchiveBoxIcon,
  PresentationChartBarIcon,
  InformationCircleIcon,
  CalendarDaysIcon,
} from '@heroicons/vue/24/outline';
import { useUiStore } from '~/stores/ui';
import { useRuntimeConfig } from '#imports';

const iconMapping: unknown = {
  home: HomeIcon,
  'rollout-project-rolloutIdentifier-rollout': CalendarDaysIcon,
  'rollout-project-rolloutIdentifier-inventory': ArchiveBoxIcon,
  'rollout-project-rolloutIdentifier-reporting': PresentationChartBarIcon,
  'rollout-project-rolloutIdentifier-knowledge-base': InformationCircleIcon,
  settings: CogIcon,
};

const { visibleItems: items, selectedRollout } = useRolloutRouting();

const resetSelectedRollout = () => {
  selectedRollout.value = false;
};

const { onItemHover } = useUiStore();

const runtimeConfig = useRuntimeConfig();
const version = ref(runtimeConfig.public.clientVersion);
</script>
